import type { GThumbnailProps } from '~/presentation/ui';

import { EMPTY_SEARCH } from '~/constants/thumbnail';
import { BlockStack, Text } from '@shopify/polaris';
import { GThumbnail } from '~/presentation/ui';

export interface GEmptySearchProps {
  heading: string;
  description: string;
  source?: GThumbnailProps['source'];
}

export const GEmptySearch: React.FC<GEmptySearchProps> = ({ source, heading, description }) => {
  return (
    <BlockStack gap="200">
      <BlockStack gap="200" inlineAlign="center">
        <GThumbnail
          source={source || EMPTY_SEARCH}
          classRemoved
          alt={heading}
          size="large"
          width="72"
          height="72"
        />

        <Text as="p" variant="bodyMd" fontWeight="semibold">
          {heading}
        </Text>
      </BlockStack>

      <Text as="p" variant="bodySm" tone="subdued">
        {description}
      </Text>
    </BlockStack>
  );
};
